import { gql } from '@apollo/client';
import { ImageMediaFragment, MediaFragment } from './programs.fragments';

const AllMoviesQuery: any = gql`
  query allMovies($skip: Int, $limit: Int) {
    programs(programTypes: MOVIE, limit: $limit, skip: $skip, sort: AIREDDATETIME) {
      totalResults
      items {
        id
        guid
        availableRegion
        slug
        type
        title
        displayGenre
        metadata
        ...ImageMedia
        ...Media
      }
    }
  }
  ${ImageMediaFragment}
  ${MediaFragment}
`;
export default AllMoviesQuery;
